import Footer from '@components/organisms/FooterNew'
import { Drawer, DrawerBody, DrawerContent } from '@nextui-org/react-latest'
import { useDisclosure } from '@nextui-org/react-latest'
import ArrowDown from '@public/static/icons/referrals/arrowDown'
import { useEffect, useState } from 'react'

type Props = {}

const StickyFooter = ({}: Props) => {
  const { isOpen, onOpenChange, onOpen, onClose } = useDisclosure()
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight
      const windowHeight = window.innerHeight
      const scrollY = window.scrollY
      const bottomOffset = scrollHeight - (scrollY + windowHeight)

      setIsVisible(bottomOffset > 300)
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      {isVisible ? (
        <div className="lg:inline hidden">
          <button
            className="fixed bottom-0 right-12 bg-white text-uguPurple z-50 rounded-t-lg text-sm font-regular px-3 py-1.5 flex items-center gap-2.5"
            style={{
              border: '1px solid rgb(223, 223, 223, 0.6)',
              boxShadow: '0 3px 10px rgba(0 0 0/0.1)',
            }}
            onClick={onOpen}
          >
            Support & Resources <ArrowDown className="rotate-180" />
          </button>
        </div>
      ) : (
        <></>
      )}
      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="bottom"
        backdrop="transparent"
        hideCloseButton
      >
        <DrawerContent className="rounded-t-3xl">
          <DrawerBody className="relative">
            <button
              className="absolute top-0 right-12 bg-white text-uguPurple z-50 text-sm font-regular px-3 py-2 flex items-center gap-2"
              onClick={onClose}
            >
              Support & Resources <ArrowDown />
            </button>
            <Footer removeTopMargin={true} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default StickyFooter
